var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',[_c('b-checkbox',{attrs:{"unchecked-value":_vm.uncheckedValue,"value":_vm.value},model:{value:(_vm.sidMutation),callback:function ($$v) {_vm.sidMutation=$$v},expression:"sidMutation"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }